<div class="row card-container" *ngIf="!pagination">
  <div class="col-12 col-md-4" *ngFor="let vacancy of vacancies">
    <div class="landing-card" [style.borderColor]="color">
      <!-- ICON PARA CURSOS -->
      <div class="d-flex align-items-center mb-2" *ngIf="vacancy?.isEducationCourse">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="20" height="20" x="0" y="0"
          viewBox="0 0 511.989 511.989" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
          <g>
            <g xmlns="http://www.w3.org/2000/svg">
              <path
                d="m470.994 330c0-24.146-17.205-44.348-40-48.994v-54.006c0-4.92-2.412-9.526-6.456-12.329s-9.206-3.445-13.811-1.716l-28.629 10.736c-18.8-19.545-41.652-34.266-66.694-43.303 24.608-18.234 40.59-47.478 40.59-80.388 0-55.141-44.859-100-100-100s-100 44.859-100 100c0 32.91 15.982 62.154 40.59 80.388-25.043 9.038-47.894 23.759-66.694 43.303l-28.629-10.736c-4.606-1.729-9.768-1.087-13.811 1.716-4.044 2.803-6.456 7.409-6.456 12.329v54.006c-22.795 4.646-40 24.847-40 48.994s17.205 44.348 40 48.994v58.006c0 6.253 3.879 11.85 9.733 14.045l160 60c3.374 1.258 7.159 1.258 10.533 0l160-60c5.854-2.195 9.733-7.792 9.733-14.045v-58.006c22.796-4.646 40.001-24.848 40.001-48.994zm-285-230c0-38.598 31.402-70 70-70s70 31.402 70 70-31.402 70-70 70-70-31.402-70-70zm70 100c35.143 0 68.709 12.701 94.899 35.393l-94.899 35.587-94.899-35.587c26.191-22.692 59.757-35.393 94.899-35.393zm-185 130c0-11.028 8.972-20 20-20h10v40h-10c-11.028 0-20-8.972-20-20zm40 49.497c11.397-2.323 20-12.424 20-24.497v-50c0-12.073-8.603-22.174-20-24.497v-31.858l130 48.75v177.961l-130-48.75zm160 95.858v-177.96l130-48.75v31.858c-11.397 2.323-20 12.424-20 24.497v50c0 12.073 8.603 22.174 20 24.497v47.108zm150-125.355h-10v-40h10c11.028 0 20 8.972 20 20s-8.971 20-20 20z"
                fill="#000000" data-original="#000000" class="" />
            </g>
          </g>
        </svg>
        <span>Curso</span>
      </div>

      <!-- ICON PARA VAGAS -->
      <div class="d-flex align-items-center mb-2" *ngIf="!vacancy?.isEducationCourse">
        <img src="assets/images/icons/vacancies-icon.png" width="20" height="20" alt="" class="mr-1">
        <span>{{!showOpportunity ? 'Vaga': 'Oportunidade'}}</span>
      </div>

      <h5 [style.color]="color">{{vacancy?.office}}</h5>
      <p [style.color]="color">{{vacancy?.area}}</p>

      <div class="items">
        <div class="d-flex">
          <i><img src="assets/images/icons/gray-location.svg" alt=""></i>
          <span
            *ngIf="vacancy?.unit[0]?.address && vacancy?.unit.length > 1 && vacancy?.showUnit">{{vacancy?.unit[0]?.address.city}}
            +{{vacancy?.unit.length -1}}</span>
          <span
            *ngIf="vacancy?.unit[0]?.address && vacancy?.unit.length === 1 && vacancy?.showUnit">{{vacancy?.unit[0]?.address.city}}</span>
          <span *ngIf="vacancy?.unit[0]?.address && !vacancy?.showUnit">Endereço Confidencial</span>
          <span *ngIf="!vacancy?.unit[0]?.address">Não Informado</span>
        </div>

        <div class="d-flex">
          <i><img src="assets/images/icons/gray-money.svg" alt=""></i>
          <span
            *ngIf="vacancy.wageType === 'exact'">{{vacancy.wage ? (vacancy.wage | currency:'BRL') : 'Não Informado'}}</span>
          <span *ngIf="vacancy.wageType === 'toCombine'">A combinar</span>
          <span
            *ngIf="vacancy.wageType === 'range' && vacancy.wageRange && vacancy.wageRange.min && vacancy.wageRange.max">{{vacancy.wageRange.min | currency:'BRL'}}
            até {{vacancy.wageRange.max | currency:'BRL'}}</span>
          <span
            *ngIf="!vacancy.wageType || (vacancy.wageType === 'range' && (!vacancy.wageRange || !vacancy.wageRange.min || !vacancy.wageRange.max))">Não
            Informado</span>
        </div>

        <h6 [style.color]="color">+ {{ vacancy?.benefits.length }} benefícios</h6>
      </div>
      <div class="landing-card-footer center-object" [style.borderColor]="color">
        <a [style.color]="color" class="btn-landing-card" (click)="openVacancy(companyKey, vacancy?.key)">Saiba Mais</a>
      </div>
    </div>
  </div>

</div>
<div class="load" *ngIf="pagination">
  <img src="assets/images/oval-page.svg" class="loading-icon" />
</div>
